import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Field, ErrorMessage, getIn, Formik, Form } from 'formik'
import { toastr } from 'react-redux-toastr'
import { memberService } from '../_services/member.service'
import * as Yup from 'yup'
import Step1 from './Step1'

import { config } from '../config'
const base_url = config.apiBaseUrl

function convertToFormData(params) {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v, k) => acc.append(`${key}[${k}]`, value))
    } else if (
      typeof value === 'object' &&
      !(value instanceof File) &&
      !(value instanceof Date)
    ) {
      Object.entries(value).forEach((v, k) => acc.append(`${key}[${k}]`, value))
    } else {
      acc.append(key, value)
    }

    return acc
  }, new FormData())
}

const initialValues = {
  classId: '',
  unionId: '',
  firstName: '',
  lastName: '',
  nationalCode: '',
  idNumber: '',
  fatherName: '',
  birthDate: '',
  isicCode: '',
  mobile: '',
  gender: '',
  imagePath: '',
  codeMeliImagePath: '',
  birthPlace: '',
  address: '',
  tels: '',
  region: '',
  codePosti: '',
  senfNumber: '',
  accept: false,
  captcha: false
}

class RegisterForm extends Component {
  state = {
    currentStep: 0,
    lastStep: 0,
    preRegisterLoading: false,
    loading: false,
    initialValues: initialValues
  }

  prevStep = props => {
    // Prev Step dont undes 0
    this.setState(state => ({
      currentStep: Math.max(state.currentStep - 1, 0)
    }))
    props.setTouched({})
  }

  nextStep = props => {
    // console.log(props.values);

    // Next Step dont go over Max step
    // console.log(props.errors);
    // props.submitForm().then(() => {
    if (props.isValid) {
      this.setState(state => ({
        currentStep: Math.min(state.currentStep + 1, state.lastStep)
      }))
      // props.validateForm();
      props.setTouched({})
    }
    // });
  }

  Step1Schema = Yup.object().shape({
    classId: Yup.string()
      .trim()
      .nullable()
      .required('تقویم کلاس'),

    unionId: Yup.string()
      .trim()
      .nullable()
      .required('اتحادیه'),

    firstName: Yup.string()
      .trim()
      .nullable()
      .required('وارد کردن [نام] الزامی است')
      .matches(
        /^[يآپچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
        {
          message: 'لطفا فقط از حروف فارسی استفاده کنید',
          excludeEmptyString: false
        }
      )
      .test('len', 'نام وارد شده نا معتبر است', val => val && val.length > 1),

    lastName: Yup.string()
      .trim()
      .nullable()
      .required('وارد کردن [نام خانوادگی] الزامی است')
      .matches(
        /^[يآپچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
        {
          message: 'لطفا فقط از حروف فارسی استفاده کنید',
          excludeEmptyString: false
        }
      )
      .test(
        'len',
        'نام خانوادگی وارد شده نا معتبر است',
        val => val && val.length > 1
      ),

    nationalCode: Yup.string()
      .trim()
      .nullable()
      .required('وارد کردن [کد ملی] الزامی است')
      .matches(/^[0-9]\d{9}$/, {
        message: 'کد ملی باید شامل 10 رقم باشد',
        excludeEmptyString: false
      }),

    idNumber: Yup.string()
      .trim()
      .nullable()
      .required('وارد کردن [شماره شناسنامه] الزامی است'),

    fatherName: Yup.string()
      .trim()
      .nullable()
      .required('وارد کردن [نام پدر] الزامی است')
      .matches(
        /^[يآپچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
        {
          message: 'لطفا فقط از حروف فارسی استفاده کنید',
          excludeEmptyString: false
        }
      )
      .test('len', 'نام وارد شده نا معتبر است', val => val && val.length > 1),

    birthDate: Yup.string()
      .trim()
      .nullable()
      .required('تاریخ تولد'),

    senfNumber: Yup.string()
      .trim()
      .nullable()
      .required('کد رهگیری (شناسه صنفی)'),

    mobile: Yup.string()
      .trim()
      .nullable()
      .required('وارد کردن [شماره موبایل] الزامی است')
      .matches(/(\+98|0)?9\d{9}/, {
        message: 'شماره موبایل وارد شده نامعتبر است',
        excludeEmptyString: false
      }),

    gender: Yup.string()
      .trim()
      .nullable()
      .required('انتخاب [جنسیت] الزامی است'),

    birthPlace: Yup.string()
      .trim()
      .nullable()
      .required('محل صدور'),

    address: Yup.string()
      .trim()
      .nullable()
      .required('نشانی واحد صنفی'),

    tels: Yup.string()
      .trim()
      .nullable()
      .required('تلن ثابت'),

    region: Yup.string()
      .trim()
      .nullable()
      .required('انتخاب [منطقه شهرداری] الزامی است'),

    codePosti: Yup.string()
      .trim()
      .nullable()
      .required('کدپستی')
      .test(
        'len',
        'کدپستی وارد شده نا معتبر است',
        val => val && val.length == 10
      ),

    isicCode: Yup.string()
      .trim()
      .nullable()
      .required('کد isic'),

    imagePath: Yup.string()
      .trim()
      .nullable()
      .required('بارگزاری [تصویر پرسنلی] الزامی است'),

    codeMeliImagePath: Yup.string()
      .trim()
      .nullable()
      .required('بارگزاری [تصویر کارت ملی] الزامی است'),

    // captcha: Yup.boolean().oneOf([true], 'لطفا عبارت امنیتی را تایید نمائید'),

    accept: Yup.boolean().oneOf(
      [true],
      'لطفا ﺷﺮاﯾﻂ و ﻗﻮاﻧﯿﻦ دوره آﻣﻮزش اﺻﻨﺎف را ﻣﻄﺎﻟﻌﻪ و ﺗﺎﯾﯿﺪ نمائید'
    )
  })
  Step2Schema = Yup.object().shape({
    // categories: Yup.array().min(1, 'حداقل 1 طبقه بندی').required('برند'),
  })
  Step3Schema = Yup.object().shape({
    // applicationPalnsId: Yup.string().trim().nullable().required('نوع کلاس پنل'),
    // userName: Yup.string().trim().nullable().required('ﻧﺎم ﮐﺎرﺑﺮی'),
    // password: Yup.string().trim().nullable().required('رﻣﺰ ورود'),
    // registerDate: Yup.string().trim().nullable().required('ﺗﺎرﯾﺦ ﺷﺮوع'),
    // expireDate: Yup.string().trim().nullable().required('ﺗﺎرﯾﺦ اﻧﻘﻀﺎء'),
  })

  schemaArray = [this.Step1Schema, this.Step2Schema, this.Step3Schema]

  // handleSubmit = (values, formikbag) => {
  //   // do stuff
  //   setTimeout(() => {
  //     formikbag.setSubmitting(false);
  //   }, 1000);
  // };

  step1 = props => {
    if (this.state.currentStep == 0) {
      return (
        <div>
          <Step1
            {...props}
            preRegisterLoading={this.state.preRegisterLoading}
            isSubmitting={this.state.loading}
            handleGetInfoByNationalCode={nationalCode =>
              this.handleGetByNationalCode(nationalCode)
            }
          />
          {/* <br/>
          <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
            مرحله بعد
          </button> */}
        </div>
      )
    }
  }

  //   step2 = props => {
  //     if (this.state.currentStep == 1) {
  //       return (
  //         <div>
  //         <Step2 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" onClick={() => { this.nextStep(props) }}>
  //             مرحله بعد
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //             مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  //   step3 = props => {
  //     if (this.state.currentStep == 2) {
  //       return (
  //         <div>
  //         <Step3 {...props} />
  //           <br/>
  //           <button className="nextButton pull-right" type="submit">
  //             ذخیره
  //           {props.isSubmitting &&
  //                     <i className="mdi mdi-24px mdi-spin mdi-loading"></i>
  //                     }
  //           </button>
  //           <button className="previousButton pull-right" onClick={() => { this.prevStep(props) }}>
  //           مرحله قبل
  //           </button>
  //         </div>
  //       );
  //     }
  //   };

  handleGetByNationalCode = nationalCode => {
    // console.log(nationalCode);
    this.setState({ preRegisterLoading: true })

    memberService
      .getByNationalCode(nationalCode)
      .then(res => {
        // console.log(res.data);
        let data = res.data[0]
        data['captcha'] = false
        data['classId'] = undefined
        this.setState({ initialValues: data, preRegisterLoading: false })
      })
      .catch(error => {
        // console.log(error);
        if (error.response.status === 404) {
          toastr.warning(error.response.data.message)
        }
        this.setState({
          initialValues: initialValues,
          preRegisterLoading: false
        })
      })
  }

  handleSubmit = values => {
    this.setState({ loading: true })
    values['accept'] = undefined
    values['captcha'] = undefined
    // console.log(JSON.stringify(values));

    memberService
      .add(JSON.stringify(values))
      .then(res => {
        var memberInfo = {}
        memberInfo = res.data
        // console.log(memberInfo);
        this.setState({ loading: false })
        toastr.success('ثبت نام', 'اطلاعات شما با موفقیت ثبت شد')
        this.props.changeMode(3, memberInfo)
        // window.location.assign(base_url + 'bank/TransferToBank/' + res.data)
      })
      .catch(error => {
        // console.log(error.response);
        this.setState({ loading: false })
        // if (error.response.status === 404) {
        //   toastr.warning(error.response.data.message);
        // }
      })
  }

  render() {
    const { currentStep, initialValues } = this.state
    const { prevStep, nextStep, schemaArray } = this
    return (
      <div className="ltr">
        <Formik
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values);
            this.handleSubmit(values)
            setSubmitting(false)
          }}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={schemaArray[currentStep]}
          render={props => <Form>{this.step1(props)}</Form>}
        />
      </div>
    )
  }
}

export default RegisterForm
